import {Divider} from 'src/design/atoms/Divider';
import {Stack} from 'src/design/atoms/Stack';
import React from 'react';
import type {UserRelatedAttachmentResponse} from 'src/api/ProactApiClient';
import {NoItemsPanel} from 'src/design/molecules/NoItemsPanel';
import {Paginator} from 'src/design/organisms/Pagination';
import {TableBodyRender} from 'src/design/molecules/TableBodyRender';
import {isValidArray} from 'src/utilities/objectUtils';
import {UserRelatedAttachmentsListRow} from './UserRelatedAttachmentsListRow';

export interface UserRelatedAttachmentsListProps {
  data: UserRelatedAttachmentResponse[];
  currentPage: number;
  totalRecords: number;
  recordsPerPage?: number;
  isLoading: boolean;
  onPageChange?: (event: React.ChangeEvent<unknown>, page: number) => void;
}

export const UserRelatedAttachmentsList = ({
  data,
  currentPage,
  totalRecords,
  recordsPerPage = 10,
  isLoading,
  onPageChange,
}: UserRelatedAttachmentsListProps) => (
  <Stack gap="xs">
    {isLoading ? (
      <TableBodyRender isLoading={isLoading} hasData={isValidArray(data)} />
    ) : (
      <>
        {data.map(row => (
          <React.Fragment key={row.id}>
            <Divider />
            <UserRelatedAttachmentsListRow data={row} />
          </React.Fragment>
        ))}
        <Paginator
          mt={24}
          perPage={recordsPerPage}
          currentPage={currentPage}
          totalRecords={totalRecords}
          onChange={onPageChange}
        />
      </>
    )}

    {data.length === 0 && !isValidArray(data) && !isLoading && (
      <NoItemsPanel
        canCreate={false}
        noItemsText="No related attachments found."
      />
    )}
  </Stack>
);
